"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as a } from "react";
import l from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ c(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.076 4.103v4.025c.336.046.846.188 1.282.604.496.473.747 1.15.747 2.019v5.18l-.01.05c-.03.191-.012.531.1.661l.001.002c.018.02.064.069.235.069q.236-.002.318-.096c.11-.13.124-.434.097-.598l-.007-.047-.001-.051V6.985S17.667 5.843 17.495 5.5c-.172-.341.266-.96.266-.96L16.485 3a.61.61 0 1 1 .94-.779l2.634 3.18v10.474c.03.229.084.98-.376 1.525-.202.244-.586.532-1.252.532-.614 0-.975-.273-1.17-.505-.47-.555-.408-1.358-.377-1.593V10.75q-.001-.784-.37-1.135a1 1 0 0 0-.438-.245v8.896c.82.07 1.466.76 1.466 1.598v1.519c0 .34-.277.616-.617.616H3.616A.616.616 0 0 1 3 21.384v-1.52c0-.878.711-1.594 1.587-1.603V4.1c0-1.146.934-2.08 2.081-2.08h7.326c1.148 0 2.082.935 2.082 2.083M4.233 20.767h12.075v-.902a.37.37 0 0 0-.37-.37h-.478a.62.62 0 0 1-.618-.618V4.103a.85.85 0 0 0-.848-.85H6.668a.85.85 0 0 0-.847.847v14.777c0 .34-.276.618-.617.618h-.601a.37.37 0 0 0-.37.37zm3.58-14.909a.37.37 0 0 1 .37-.37h4.176a.37.37 0 0 1 .37.37V7.8a.37.37 0 0 1-.37.37H8.182a.37.37 0 0 1-.37-.37zm.37 3.545h4.176c.884 0 1.602-.719 1.602-1.603V5.858c0-.885-.718-1.603-1.602-1.603H8.182c-.884 0-1.604.718-1.604 1.603V7.8c0 .884.72 1.603 1.604 1.603",
        clipRule: "evenodd"
      }
    )
  }
), m = a(e);
export {
  m as Gas,
  m as default
};
